import type { ID } from '@nutralab/api';
export function getOfferPath(offer: { id: ID; slug?: string | null }): string {
    return offer.slug ? `/offers/${offer.id}-${encodeURIComponent(offer.slug)}` : `/offers/${offer.id}`;
}
